import $ from 'jquery';
class Reps {
    constructor(){
        this.allData;
        var usersData;
        var regData;
        var eventDta;
        var allCheckbox = $("#all-checkbox");
        if ($("#reps-club").length != 0){
            this.events();
        }
    }

    events() {
        //this.getRepsData.bind(this);
        this.getRepsData();
        //  Register Listeners only if on page
        $("#all-checkbox").on("change", this.toggleAllMembersSelected.bind(this));
        $("#reps-club").on("change", this.newClubSelected.bind(this));
        $("#reg-switch").on("change", this.toggleRegOnOff.bind(this));
        $("#message-text").on("input", this.checkTextareaLength.bind(this));
        $("#send-message").on('click', this.getRecipients.bind(this));
        $("#msg-recipients").on('click', this.changeRecipients.bind(this));
        $("#unapprove-members-bttn").on('click', this.getUnapproveList.bind(this));
        $("#tab-dispute").on('click', this.tabSelected.bind(this));
        $("#tab-general").on('click', this.tabSelected.bind(this));
        $(document).on("click", "input[type='checkbox']", this.memberCheckboxClicked.bind(this));

    }

    toggleAllMembersSelected(e){
        if ($('#all-checkbox').is(":checked")){
            this.changeCheckboxes(true);
        }
        else {
            this.changeCheckboxes(false);
        }
        evaluateButtonState();
    }
    selectDeselectAttendee(e){
        if ($('#msg-recipients').attr('data-recipients') == 'E'){
            if ($(e.target.parentElement).hasClass('attendee-selected')){
                $(e.target.parentElement).removeClass('attendee-selected');
            } else {
                $(e.target.parentElement).addClass('attendee-selected')
            }
        }
        evaluateButtonState();
    }

    tabSelected(e){
        switch ($(e.target).attr('id')){
            case "tab-general":
                $("#tab-general").addClass('tab-active');
                $("#tab-dispute").removeClass('tab-active');
                $("#general-docs").removeClass('d-none');
                $("#dispute-docs").addClass('d-none');
                break;
            case "tab-dispute":
                $("#tab-general").removeClass('tab-active');
                $("#tab-dispute").addClass('tab-active');
                $("#general-docs").addClass('d-none');
                $("#dispute-docs").removeClass('d-none');
                break;
        }
    }
    changeRecipients(e){
        if ($('#msg-recipients').attr('data-recipients') == "M"){
            $('#msg-recipients').text("Message Event Attendees");
            $('#msg-recipients').attr('data-recipients', 'E');
            setAttendeesToSelected(true);
        } else {
            $('#msg-recipients').text("Message Selected Members");
            $('#msg-recipients').attr('data-recipients', 'M');
            setAttendeesToSelected(false);
        }
        evaluateButtonState();
    }
    memberCheckboxClicked(e){
        evaluateButtonState();
    }
    getRecipients(e){
        var members = "";
        var selected = [];
        members = getSelectedMembers();
        if (members.length > 0 ){
            members = members.substring(0, members.length - 1);
            $("#to-members").val(members);
            $(".mask").height($(document).height());
            $(".mask").show();
            $('#dys-spinner').addClass('d-flex');
        } else {
            e.preventDefault();
            $("#to-members").val("");
        }
    }
    getUnapproveList(e){
        var members = "";
        members = getSelectedMembers();
        if (members.length > 0 ){
            members = members.substring(0, members.length - 1);
            $("#unapproveMembers").val(members);
        } else {
            e.preventDefault();
            $("#unapproveMembers").val("");
        }
    }

    checkTextareaLength(e){
        evaluateButtonState();
    }

    changeCheckboxes(checked){
        $('#local-members-list input[type="checkbox"]').each(function() {
            ($(this).prop('checked',checked));
        });
    }

    toggleRegOnOff(e){
        var clubToggle = {
            'CLUB': $('#reps-club').val()
        }
        var eventID = $('#event-input').val().toString();
        var clubSelected = $('#reps-club').val();
        if ($('#reg-switch').is(':checked')){
            clubToggle.SWITCH  = "ON";
            this.allData[clubSelected].event[0].ALLOW=1;
            $('#reg-status').hide();
            $('#reg-status').text("Registration Open");
            $('#reg-status').fadeIn(500);
        }
        else {
            this.allData[clubSelected].event[0].ALLOW=0;
            clubToggle.SWITCH  = "OFF";
            $('#reg-status').hide();
            $('#reg-status').text("Registration Closed");
            $('#reg-status').fadeIn(500);
        }
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/dys/v1/openRegistration/',
            data: clubToggle,
            type: 'POST',
            success: (response) =>{
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });
    }

    getRepsData(){
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/dys/v1/clubRepData/',
            type: 'POST',
            success: (response) =>{
                console.log(response);
                this.allData = response;
                this.updateDOMwithRepsData();
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });
    }
    newClubSelected(e){
        this.updateDOMwithRepsData();
        evaluateButtonState();
    }

    updateDOMwithRepsData(){
        var clubSelected = $("#reps-club").val();
        $('#from-club').val(clubSelected);
        $('#selected-club').val(clubSelected);
        $('#selected-club-2').val(clubSelected);
        this.showMembers(clubSelected);
        this.showRegistrations(clubSelected);
        this.showUnApproved(clubSelected);
        this.showMsgData(clubSelected);

    }
    showMsgData(clubSelected){
        this.clubInfo = this.allData[clubSelected]["clubInfo"];
        $('#club-name').hide();
        $('#club-email').hide();
        $('#club-name').text(this.clubInfo[0].CLUBNAME);
        $('#club-email').text(this.clubInfo[0].CLUBEMAIL);
        $('#club-name').fadeIn(500);
        $('#club-email').fadeIn(500);
    }
    showMembers(clubSelected){
        this.usersData = this.allData[clubSelected]["clubMembers"];

        $('#local-members-list').empty();
        $('#local-members-list').hide();

        for (var key in this.usersData){
            if (this.usersData[key].approved=="YES"){
                $('#local-members-list').append(`<p><input type="checkbox" class="mr-1" name="member${this.usersData[key].ID}"></input>${this.usersData[key].name}</p>`);
            }
        }
        //  Uncheck the all checkbox
        if ($('#all-checkbox').is(":checked")){
            $('#all-checkbox').prop('checked', false);
        }
        $('#local-members-list').fadeIn(500);
    }
    showRegistrations(clubSelected){
        this.regData = this.allData[clubSelected]["registrations"];
        this.eventData = this.allData[clubSelected].event;
        $('#pre-registrations').empty();
        var foundReg = false;

        //  If no event found then clear DOM
        if (Object.keys(this.eventData).length === 0){
            $('#pre-registrations').append(`<div class="row">
            <h4 class="text-center col-12">No future events for this Club</h4></div>`);
            $('#reg-switch-box').fadeOut(500);
            $('#event-input').val("");
        } else {
            $('#event-input').val(this.eventData[0].EVENT_ID);
            $('#reg-switch-box').removeAttr('display');
            $('#reg-switch-box').fadeIn(500);
            if (this.eventData[0].ALLOW == 0){
                $('#reg-switch').prop('checked',false);
                $('#reg-status').text("Registration Closed");
            } else {
                $('#reg-switch').prop('checked',true);
                $('#reg-status').text("Registration Open");
            }
            $('#pre-registrations').append(`
                <div class="row">
                    <h4 class="text-center col-12">Pre-Registrations for Local Event</h4>
                </div>
                <div class="row text-reverse">
                    <p class="col-5">Name</p>
                    <p class="col-3 pl-0">Boat</p>
                    <p class="col-2 pl-0">Sail</p>
                    <p class="col-2 text-center pl-0">Fleet</p>
                </div>
                <div id="registrations-list">
                </div>`);
                $('#registrations-list').hide();
            for (var key in this.regData){
                foundReg = true;
                $('#registrations-list').append(`<div class="row event-attendee" id="sailor-${key}"  data-member="${this.regData[key].MEMBER}">`);
                $(`#sailor-${key}`).append(`<p class="col-5 my-auto">${this.regData[key].NAME}</p>`);
                $(`#sailor-${key}`).append(`<p class="col-3 my-auto pl-0">${this.regData[key].BOAT}</p>`);
                if (this.regData[key].SAIL.startsWith("LOAN")){
                    $(`#sailor-${key}`).append(`<p class="col-2 my-auto error-message pl-0">${this.regData[key].SAIL}</p>`);
                } else {
                    $(`#sailor-${key}`).append(`<p class="col-2 my-auto pl-0">${this.regData[key].SAIL}</p>`);
                }
                ///////////////////////////////////////////////////////////////////////
                /*    Modification <MOD-A102>       DELETED
                ///////////////////////////////////////////////////////////////////////
                $(`#sailor-${key}`).append(`<p class="col-2 my-auto pl-0 text-center">${this.regData[key].SY}</p>`);
                //////////////////////////////////////////////////////////////////////*/
                /*    Modification <MOD-A102>       ADDED
                /////////////////////////////////////////////////////////////////////*/
                $(`#sailor-${key}`).append(`<p class="col-2 my-auto pl-0 text-center">${this.regData[key].FLEET}</p>`);
                //////////////////////////////////////////////////////////////////////*/

                
            }
            $(".event-attendee").on('click', this.selectDeselectAttendee.bind(this));
            if (!foundReg){
                $('#registrations-list').append(`<p class="col-12 text-center text-style__heading">No Registrations Yet</p>`);
            }

            $('#registrations-list').fadeIn(500);
        }
    }
    showUnApproved(clubSelected){
        this.usersData = this.allData[clubSelected]["clubMembers"];
        $('#unapproved-members').empty();
        var foundUnapproved = false;

        //  If no event found then clear DOM
        if (Object.keys(this.usersData).length === 0){
            $('#unapproved-members').addClass('d-none');
        } else {
            $('#unapproved-members').append(`
                <div class="row">
                    <h4 class="text-center col-12">Un-Approved Members</h4>
                </div>
                <div class="row text-reverse">
                <p class="col-4">User Name</p>
                <p class="col-4">Email</p>
                </div>
                <div id="unapproved-list">
                </div>`);
            $('#unapproved-list').hide();
            for (var key in this.usersData){
                if (this.usersData[key].approved == "NO"){
                    foundUnapproved = true;
                    $('#unapproved-list').append(`<div class="row" id="unapp-${key}">`);
                    $(`#unapp-${key}`).append(`<p class="col-4"><input type="checkbox" class="mr-1" name="unapprovedmembers[]" value="${this.usersData[key].ID}"></input>${this.usersData[key].name}</p>`);
                    $(`#unapp-${key}`).append(`<p class="col-4">${this.usersData[key].email}</p>`);
                }
            }
            $('#unapproved-list').append('<input class="bttn m-1 col-5 col-sm-4 col-md-3 col-xl-2" type="submit" value="Approve Selected" name="bttnApprove">');

            $('#unapproved-list').fadeIn(500);
        }
        if (foundUnapproved){
            $('#unapproved-members').removeClass('d-none');

        } else {
            $('#unapproved-members').addClass('d-none');
        }
    }
}
function setAttendeesToSelected(b){
    var attendees = document.getElementsByClassName("event-attendee");
    for (var a=0; a < attendees.length; a++){
        if (b){
            $(attendees[a]).addClass("attendee-selected");
        } else {
            $(attendees[a]).removeClass("attendee-selected");
        }
    }
    evaluateButtonState();
}

function getSelectedMembers(){

    //set members to 1 member indicating that it is for registrations.
    var members = "";
    if ($('#msg-recipients').attr('data-recipients') == 'E'){
        //  The following line taken out to allow selection of attendees rather than sending event ID and having
        //  all attendees receive the email.
        //members = "EventID-" + $('#event-input').val().toString() + ",";
        //  It was replaced by the following code
        var attendees = document.getElementsByClassName('attendee-selected');
        for (var a=0; a < attendees.length; a++){
            members += $(attendees[a]).data('member') + ",";
        }

        //******************************************************** */
    } else {
        $('input[type=checkbox]').each(function() {
            if (this.checked && $(this).attr('name')) {
                if ($(this).attr('name').startsWith('member')){
                    members += $(this).attr('name') + ",";
                }
            }
        });
    }

    return members;
}

function anyRecipients(){
    var foundRecipients = false;
    if ($('#msg-recipients').attr('data-recipients') == 'M'){
        $('input[type=checkbox]').each(function() {
            if ($(this).is(':checked') && $(this).attr('name')) {
                if ($(this).attr('name').startsWith('member')){
                    foundRecipients = true;
                }
            }
        });
    } else {
        //var registrations = $('#registrations-list .row').length;
        var registrations = document.getElementsByClassName('attendee-selected').length;
        if (registrations > 0){
            foundRecipients = true;
        }
    }



    return foundRecipients;
}

function evaluateButtonState(){
    if (anyRecipients()){
        setNoRecipientMessage(false);
        if (hasMessage()){
            $('#send-message').removeClass('bttn-disabled');
            $('#send-message').removeAttr('disabled');
        } else {
            $('#send-message').addClass('bttn-disabled');
            $('#send-message').attr('disabled',true);
        }
    } else {
        setNoRecipientMessage(true);
        $('#send-message').addClass('bttn-disabled');
        $('#send-message').attr('disabled',true);
    }
}

function hasMessage(){
    var hasMsg = false;
    if ($("#message-text").val().length > 0){
        hasMsg = true;
    }
    return hasMsg;
}

function setNoRecipientMessage(showNoRecipients){
    if (showNoRecipients){
        if ($('#msg-recipients').attr('data-recipients') == "E"){
            $('.no-members').html('No Attendees selected for message');
        } else {
            $('.no-members').html('No Members selected for message');
        }
        $('.no-members').removeClass('d-none');
        $('.selected-members').addClass('d-none');
        $('.event-attendees').addClass('d-none');
    } else {
        $('.no-members').addClass('d-none');
        if ($('#msg-recipients').attr('data-recipients') == "E"){
            $('.event-attendees').removeClass('d-none');
            $('.selected-members').addClass('d-none');
        } else {
            $('.selected-members').removeClass('d-none');
            $('.event-attendees').addClass('d-none');
        }
    }
}

export default Reps;